import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isShowChat:false,
    VATitle:"",
    isFindModule:false
}

export const virtualAssistSlice = createSlice({
  name: 'virtualAssist',
  initialState,
  reducers: {
    setIsShowChat: (state, action) => {
      state.isShowChat = action.payload;
    },
    setVATitle: (state, action) => {
      state.VATitle = action.payload;
    },
    setIsFindModule: (state, action) => {
      state.isFindModule = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsShowChat, setVATitle, setIsFindModule } = virtualAssistSlice.actions

export default virtualAssistSlice.reducer